import i18n from "@/i18n";

const routes = {
  path: "/member",
  name: "Member",
  component: () =>
    import(/* webpackChunkName: "member" */ "@/views/member/Main"),
  children: [
    {
      path: "list",
      alias: "",
      name: "MemberList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/List"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.member_list"),
        step: [
          i18n.t("menu.membership.membership"),
          i18n.t("menu.membership.member"),
        ],
        menu_num: 1,
        sub_menu_num: 11,
        location: "/member/list",
      },
    },
    {
      path: "view/:playerno",
      name: "MemberView",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/View"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.member_view"),
        step: [
          i18n.t("menu.membership.membership"),
          i18n.t("menu.membership.member"),
        ],
        menu_num: 1,
        sub_menu_num: 11,
        location: "/member/list",
      },
    },
    {
      path: "lockerview",
      name: "LockerView",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/LockerView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.locker_room"),
        step: [
          i18n.t("menu.membership.membership"),
          i18n.t("page.membership.locker_room"),
        ],
        menu_num: 1,
        sub_menu_num: 12,
        location: "/member/lockerview",
      },
    },
    {
      path: "pointlist",
      name: "PointList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/PointList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.bucks_history"),
        step: [
          i18n.t("menu.membership.membership"),
          i18n.t("page.membership.bucks_history"),
        ],
        menu_num: 1,
        sub_menu_num: 13,
        location: "/member/pointlist",
      },
    },
    // {
    //   path: "pointadd/:recordno?",
    //   name: "pointAdd",
    //   component: () =>
    //     import(/* webpackChunkName: "member" */ "@/views/member/PointAdd"),
    //   prop: true,
    //   meta: {
    //     layout: "DefaultLayout",
    //     wrapId: "sub",
    //     subtitle: "Point Add",
    //     step: ["Membership", "Point Add"],
    //     menu_num: 1,
    //     sub_menu_num: 13,
    //   },
    // },
  ],
};

export default routes;
